<template>

<div class="demo-body">
  <div class="inner">
    <slot />
  </div>
</div>

</template>

<style lang="scss" scoped>

.demo-body {
  padding: 100px 24px;
  background-color: #F5F5F5;

  @media screen and (max-width: 940px) {
    padding: 20px 24px;
    // padding: 60px 24px;
  }
  @media screen and (max-width: 768px) {
    padding: 60px 24px;
  }
  @media screen and (max-width: 640px) {
    padding: 60px 16px;
  }
  .inner {
    max-width: 1200px;
    margin: 0 auto;
  }
}

</style>